/**
 * Composable for branding-related utilities
 * Provides methods to customize text with installation-specific branding
 */
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store.js';

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  const installationName = computed(
    () => globalConfig.value?.installationName || 'Chatwoot'
  );

  /**
   * Replaces "Chatwoot" in text with the installation name from global config
   * @param {string} text - The text to process
   * @returns {string} - Text with "Chatwoot" replaced by installation name
   */
  const replaceInstallationName = text => {
    if (!text) return text;

    if (!installationName.value) return text;

    return text.replace(/Chatwoot/g, installationName.value);
  };

  const installationSlug = computed(() => {
    const normalized = installationName.value.normalize('NFKD');
    const asciiOnly = Array.from(normalized)
      .filter(char => char.charCodeAt(0) <= 0x7f)
      .join('');

    return (
      asciiOnly
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/^-+|-+$/g, '') || 'chatwoot'
    );
  });

  const buildBackupCodesText = backupCodes =>
    `${installationName.value} Two-Factor Authentication Backup Codes\n\n${backupCodes.join('\n')}\n\nKeep these codes in a safe place.`;

  const buildBackupCodesFilename = () =>
    `${installationSlug.value}-backup-codes.txt`;

  return {
    installationName,
    replaceInstallationName,
    buildBackupCodesText,
    buildBackupCodesFilename,
  };
}
